var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('div', {
    staticClass: "popPrompt popStake",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.onClose
    }
  }), _c('transition', {
    attrs: {
      "appear": "",
      "name": "popPromptCenter"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "popPrompt-main center"
  }, [_c('div', {
    staticClass: "btn-close btn",
    on: {
      "click": _vm.onClose
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _c('div', {
    staticClass: "popPrompt__title"
  }, [_vm._v("STAKE")]), _c('div', {
    staticClass: "popPrompt-con"
  }, [_c('div', {
    staticClass: "popSlippage__amount"
  }, [_c('span', [_vm._v("My MARSP:")]), _vm._v(" " + _vm._s(_vm.web3Data.myMaspBalance !== null ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.myMaspBalance), 4, true, false) : "--"))]), _c('div', {
    staticClass: "popStake-input hover",
    class: _vm.err && 'err'
  }, [_c('div', {
    staticClass: "popStake-input-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.amount,
      expression: "amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.amount
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.amount = $event.target.value;
      }, _vm.onInput]
    }
  })])]), _vm.err ? _c('div', {
    staticClass: "popSlippage__error"
  }, [_vm._v(_vm._s(_vm.err))]) : _vm._e(), _c('div', {
    staticClass: "popStake-switch"
  }, _vm._l([0.1, 0.2, 0.5, 0.8, 1], function (item, index) {
    return _c('div', {
      staticClass: "popStake-switch__item hover",
      class: _vm.selectSwitch == item && 'active',
      on: {
        "click": function ($event) {
          return _vm.onSwitch(item);
        }
      }
    }, [_vm._v(_vm._s(item * 100) + "%")]);
  }), 0), [_vm.isBtnLoading ? _c('div', {
    staticClass: "btn-apply btn"
  }, [_c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  })]) : _c('div', {
    staticClass: "btn-apply btn",
    on: {
      "click": _vm.onApply
    }
  }, [_vm._v(_vm._s(_vm.$lang("Stake")))])]], 2)])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };